function departmentsShowHandler(){
    const departmentsLinks = document.querySelectorAll('.departments__link');
    departmentsLinks.forEach(link =>{
        let indexOfHide = (link.classList.contains('departments__link--phone')) ? 7 : link.innerText.indexOf('@')+1;
        let fullAddress = link.innerText;
        link.dataset.departments = fullAddress;
        let hidenAddres = fullAddress.substring(0, indexOfHide) + '***';
        link.innerText = hidenAddres;
    })

    const showBtns = document.querySelectorAll('.show');
    showBtns.forEach(btn => btn.addEventListener('click', (event) =>{
        event.preventDefault();
        event.currentTarget.style.display = 'none';
        event.currentTarget.previousElementSibling.innerText = event.currentTarget.previousElementSibling.dataset.departments;
    }))
}

function addLabelAnimation(){
    const inputs = document.querySelectorAll('.contact__input');
    inputs.forEach(elem => {
        elem.addEventListener('focusin', (event) => {
            event.currentTarget.parentElement.parentElement.firstElementChild.dataset.selected = 1;
        })
        elem.addEventListener('focusout', (event) => {
            if(!event.currentTarget.value) event.currentTarget.parentElement.parentElement.firstElementChild.dataset.selected = 0;
        })
    })
    if(document.querySelector('#actualDate')) document.querySelector('#actualDate').parentElement.parentElement.firstElementChild.dataset.selected = 1;
}

function setFormCheckboxDataset(){
    let checkbox = document.querySelector('.contact__checkbox');
    if(checkbox){
    checkbox.dataset.checked = '0';
    checkbox.addEventListener('click', (event) =>{
        event.currentTarget.dataset.checked = (event.currentTarget.dataset.checked == 0) ? 1 : 0;
    })}
}

function openHamburger(){
    let hamburger = document.querySelector('.menu-hamburger');
    let menu = document.querySelector('.nav__menu .menu');
    let buttons = document.querySelector('.nav__buttons');
    let logo = document.querySelector('.nav__logo');
    appendButtonsToMenu(menu, buttons);
    hamburger.addEventListener('click', (event) =>{
        event.currentTarget.classList.toggle('menu-hamburger--opened');
        event.currentTarget.setAttribute('aria-expanded', event.currentTarget.classList.contains('.menu-hamburger--opened'));
        if(event.currentTarget.classList.contains('menu-hamburger--opened')){
            menu.style.top = '0';
            logo.classList.add('nav__logo--active');
        }
        else {
            menu.style.top = '-1000px';
            logo.classList.remove('nav__logo--active');
        }
    })
}

function appendButtonsToMenu(menu, buttons){
    if (window.matchMedia("(max-width: 1155px)").matches) {
        menu.append(buttons);
        buttons.firstElementChild.classList.add('btn--light-bg');
    }

    $(window).on('resize', function(){
        if (window.matchMedia("(max-width: 1155px)").matches) {
            menu.append(buttons);
            buttons.firstElementChild.classList.add('btn--light-bg');
        }
        if (window.matchMedia("(min-width: 1155px)").matches) {
            document.querySelector('.nav__container').insertBefore(buttons, document.querySelector('.menu-menu-jezykow-container'));
            buttons.firstElementChild.classList.remove('btn--light-bg');
        }
    });
}

function toggleDepartmentsArrow(){
    const departments = document.querySelectorAll('.departments__item');
    departments.forEach(department => department.addEventListener('click', (event) =>{
        if(window.matchMedia("(max-width: 990px)").matches){
            let arrow = event.currentTarget.firstElementChild.lastElementChild;
            (arrow.classList.contains('departments__arrow--active')) ?  
                arrow.classList.remove('departments__arrow--active') :
                arrow.classList.add('departments__arrow--active');
        }
    }))
}

function toggleDepartmentsInfo(){
    var departments = $('.departments__item');
    departments.on('click', function(){
        if(window.matchMedia("(max-width: 990px)").matches){
            $(this).children().next().slideToggle('medium');
        }
    })
}

function toggleDepartments(){
    toggleDepartmentsArrow();
    toggleDepartmentsInfo();
}

function openSlide(item, lightbox ,index){
  item.addEventListener('click', (event)=>{
    lightbox.openAt(index);
  })
}

function setLightboxToGallery(){
    setTimeout(() =>{
        const gallery = document.querySelectorAll('.career-gallery__slide');
        const galleryImg = [];
        gallery.forEach((item, index) =>{
          item.firstElementChild.setAttribute('href',item.firstElementChild.getAttribute('src'));
          galleryImg.push({
            'href': item.firstElementChild.getAttribute('src')
          })
        })
        const lightbox = GLightbox({
            touchNavigation: true,
            autoplayVideos: true,
        });
        lightbox.setElements([...galleryImg]);
        gallery.forEach((item, index) => openSlide(item, lightbox, index));
    }, 100)
}

function setLightboxToCarsGallery(){
    setTimeout(() =>{
        const gallery = document.querySelectorAll('.cars-gallery__img-container');
        const galleryImg = [];
        gallery.forEach((item, index) =>{
          item.firstElementChild.setAttribute('href',item.firstElementChild.getAttribute('src'));
          galleryImg.push({
            'href': item.firstElementChild.getAttribute('src')
          })
        })
        const lightbox = GLightbox({
            touchNavigation: true,
            autoplayVideos: true,
        });
        lightbox.setElements([...galleryImg]);
        gallery.forEach((item, index) => openSlide(item, lightbox, index));
    }, 100)
}

function setLightboxToVideo(){
    setTimeout(() =>{
        const gallery = document.querySelectorAll('.btn-video');
        const galleryImg = [];
        gallery.forEach((item, index) =>{
          item.setAttribute('href',item.firstElementChild.getAttribute('src'));
          
          galleryImg.push({
            'href': item.firstElementChild.getAttribute('src')
          })
        })
        const lightbox = GLightbox({
            touchNavigation: true,
            autoplayVideos: true,
        });
        lightbox.setElements([...galleryImg]);
        gallery.forEach((item, index) => openSlide(item, lightbox, index));
    }, 100)
}

function setLightboxToBlogGallery(){
  const gallery = document.querySelectorAll('.blocks-gallery-item');
  const galleryImg = [];
  gallery.forEach(item =>{
    item.firstElementChild.setAttribute('href',item.firstElementChild.firstElementChild.getAttribute('src'));
    galleryImg.push({
      'href': item.firstElementChild.firstElementChild.getAttribute('src')
    })
  })
  const lightbox = GLightbox({
      touchNavigation: true,
      autoplayVideos: true,
  });
  lightbox.setElements([...galleryImg]);
  gallery.forEach((item, index) => openSlide(item, lightbox, index));
}

function careerToggle(){
    const applyBtn = $('.career-offers__btn');
    applyBtn.on('click', function(event){
        event.preventDefault();
        $(this).parent().next().slideToggle('medium');
    })
}

function addImgToCareerForm(){
    const img = document.querySelector('.contact__file-icon');
    if(img){
        let urlToImg = load_more_news_params.template_directory + '/images/file-send-icon.svg'
        img.setAttribute('src', urlToImg);
    }
}

function displayFileName(){
    const fileBtn = document.querySelector('.btn-file');
    if(fileBtn){
        const fileInput = $('#file-424');
        const img = document.querySelector('.contact__file-icon');
        const form = document.querySelector('.contact__file-name--text');
        fileInput.on('change', function(event){
            form.innerHTML = event.currentTarget.files[0] ? event.currentTarget.files[0].name : '';
            (fileBtn.classList.contains('btn-file--uploaded') && !event.currentTarget.files[0]) ? fileBtn.classList.remove('btn-file--uploaded') : fileBtn.classList.add('btn-file--uploaded');
            let urlToImg = (event.currentTarget.files[0]) ? load_more_news_params.template_directory + '/images/file-sended-icon.svg' : load_more_news_params.template_directory + '/images/file-send-icon.svg';
            img.setAttribute('src', urlToImg);
        })
    }
}

function resetFileInput(){
    const fileInputContainer = document.querySelector('.btn-file');
    const fileInput = document.querySelector('#file-424');
    const filesNames = document.querySelector('.contact__file-name--text');
    const filesIcon = document.querySelector('.contact__file-icon');
    fileInput.value = "";
    filesNames.innerText = '';
    let urlToImg = load_more_news_params.template_directory + '/images/file-send-icon.svg';
    filesIcon.setAttribute('src', urlToImg);
    if(fileInputContainer.classList.contains('btn-file--uploaded')) fileInputContainer.classList.remove('btn-file--uploaded')
}

function showHideInput(value){
    const fileInputContainer = document.querySelector('.btn-file');
    switch(value){
        case 'Tak':
        case 'Yes':
        case 'Ja':
        case 'Oui':
        case 'Si':
            resetFileInput();
            fileInputContainer.style.display ="flex";
            break;
        case 'Nie':
        case 'No':
        case 'Nein':
        case 'Non':
            resetFileInput()
            fileInputContainer.style.display ="none";
            break;
    }
}

function displayFileInput(){
    const radio = document.querySelectorAll('input[name="pytanie"]');
    if(radio.length){
        radio.forEach(rad => rad.addEventListener('change', (event) => {
            showHideInput(event.currentTarget.value);
        }))
        window.addEventListener('load', () =>{
            const value = document.querySelector('input[name="pytanie"][checked="checked"]').value;
            showHideInput(value);
        })
    }
}

function smoothScroll(){
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

  $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
  }, 500);
});
}



displayFileInput();
displayFileName();
addImgToCareerForm();
careerToggle();
setLightboxToBlogGallery();
setLightboxToGallery();
addLabelAnimation();
departmentsShowHandler();
setFormCheckboxDataset();
openHamburger();
toggleDepartments();
setLightboxToCarsGallery();
smoothScroll();
